export default /*@ngInject*/ function ($http) {

    this.getPasswordExpirationTypes = function () {
        return [
            'Days',
            'Accesses',
            'None'
        ];
    };

    this.getOracleCloudRoles = function () {
        return $http({
            method: 'GET',
            url: apiUrl + 'api/identitymanager/orfc/roles'
        });
    };

    this.getDataAccessAssignments = function (userName, roleName) {
        return $http({
            method: 'GET',
            url: apiUrl + 'api/identitymanager/orfc/dataaccessassignments/user/' + encodeURIComponent(userName) + '/role/' + encodeURIComponent(roleName)
        });
    };

    this.getSecurityContexts = function () {
        return $http({
            method: 'GET',
            url: apiUrl + 'api/identitymanager/orfc/securitycontexts'
        });
    };

}